(function() {
    'use strict';
 
     //***************************************************************************//
    //************ Redirect HTTP401 to login page, examine json format on success
    //***************************************************************************//
    // register the interceptor as a service
    a3_pilot_reports.factory('http401interceptor', http401interceptor)

    /* @ngInject */ 
    function http401interceptor($q,$location, $log){
        return {

          'response': function(response) {
            // do something on success
            //expecting specific object as a response: success:true/false,errorMessage:string,data:any not null object
            //var contentType=response.headers("content-type");
            var header = "";
            if(response && response.headers() && response.headers("content-type")) header = response.headers("content-type").substring(0,16);
            if (header==="application/json")
            {
                var errorMessage="";
                var isError=false;
                if (response==null || response.data==null || response.data.success==null || response.data.errorMessage==null || response.data.data==='undefined')
                {
                    isError=true;
                    errorMessage="Server response not found";
                }
                else if (response.data.success==false)
                {
                    isError=true;
                    errorMessage=response.data.errorMessage;
                }
                if (isError) $q.reject(response,errorMessage);
            }
            return response || $q.when(response);
          },

          // optional method
         'responseError': function(rejection) {
            if(rejection.status === 401){
                $log.error('Authorization failed. Need to login again');
                if ($location.path()!='/login'){
                    $location.path('/login');
                    //force refresh so that the browser will download any updates from the cache.manifest
                    //without refresh, user may stick to an older version for ever
                    setTimeout(function(){window.location.reload(true);},1000);
                }
              return $q.reject(rejection);
            }
            else{
                  return $q.reject(rejection); 
            }
          }
        };
    };

 })();   